// SEO host handling (owner-confirmed 2026-10):
// - Preview builds (REACT_APP_BACKEND_URL on *.preview.emergentagent.com): canonicals stay on
//   the preview host and every page is forced noindex,follow — never indexed.
// - Production builds: canonicals/OG/schema use the verified published domain
//   REACT_APP_SITE_URL (https://dallasjuicecompany.com), public pages stay indexable.
const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const IS_PREVIEW = /\.preview\.emergentagent\.com$|localhost|127\.0\.0\.1/.test(BACKEND || "");
export const SEO_SITE_URL = IS_PREVIEW ? BACKEND : (process.env.REACT_APP_SITE_URL || BACKEND);
